// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["modules/react-player","modules/swiper","modules/dompurify","modules/prop-types","modules/react-is","modules/body-scroll-lock","modules/lightbox"], () => (__webpack_require__("./blocks/components/lightbox/script.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
